class UpdateArticleUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * @param {string} articleId
     * @param {object} updates
     * @returns {Promise<void>}
     */
    async execute(articleId, updates) {
        return this.articleRepository.updateArticle(articleId, updates);
    }
}

export default UpdateArticleUseCase;
